import React from "react";

import styles from "./Address.module.scss";
import AddressTile from "./AddressTile";
import DestinationOption from "../../components/DestinationOption/DestinationOption";

const RMDAddresses = ({
  combinedUniqueAddress,
  uniqueRolloverAddress,
  uniqueTraditionalAddress,
  RMDClient,
  primaryAddress,
}) => {
  if (RMDClient) {
    if (combinedUniqueAddress.length === 1) {
      const isDisabled =
        combinedUniqueAddress[0].serviceId ||
        combinedUniqueAddress[0].restrictAddress;
      return (
        <div>
          {" "}
          <DestinationOption
            isSelected={!isDisabled}
            disabled={isDisabled}
            addressLock={true}
            blockContainer={true}
            optionText={
              <AddressTile
                address={combinedUniqueAddress[0]}
                primaryAddress={primaryAddress}
              />
            }
            selectable={false}
            value={1}
          />
        </div>
      );
    }
    return (
      <div className={styles["subtitle-container"]}>
        {uniqueRolloverAddress.length > 0 && (
          <div>
            <div className={styles.subtitle}>
              RMD from your Rollover IRA investments will be <span className="orphan-line"> sent to:</span>
              </div>
            {uniqueRolloverAddress.map((address, index) => {
              const isDisabled =
                address.serviceId ||
                address.restrictAddress;
              return (
                <DestinationOption
                  key={index}
                  isSelected={!isDisabled}
                  addressLock={true}
                  blockContainer={true}
                  disabled={isDisabled}
                  optionText={
                    <AddressTile
                      address={address}
                      primaryAddress={primaryAddress}
                    />
                  }
                  selectable={false}
                  value={1}
                />
              );
            })}
          </div>

        )}
        {uniqueTraditionalAddress.length > 0 && (

          <div>
            <div className={styles.subtitle}>
              RMD from your Traditional IRA investments will be sent to:
              </div>
            {uniqueTraditionalAddress.map((address, index) => {
              const isDisabled =
                address.serviceId ||
                address.restrictAddress;
              return (
                <DestinationOption
                  key={index}
                  isSelected={!isDisabled}
                  addressLock={true}
                  blockContainer={true}
                  disabled={isDisabled}
                  optionText={
                    <AddressTile
                      address={address}
                      primaryAddress={primaryAddress}
                    />
                  }
                  selectable={false}
                  value={1}
                />
              );
            })}
          </div>
        )}
      </div>
    );
  }
  return <div />;
};

export default RMDAddresses;
